import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "react-toastify/dist/ReactToastify.css";
import { prepareSuperUserLogin } from "./utils/superUserLogin";

// A super-admin "Open their dashboard" link replaces whatever session is in the browser.
prepareSuperUserLogin();

ReactDOM.render(<App />, document.getElementById("root"));
